module.exports = __webpack_public_path__ + "static/media/5_r_ruini1_77.4_67.96.5feebb3a.png";